import "../../../field.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.ConfirmationStep ??= {};

AppointmentBooking.Wizard.Views.ConfirmationStep.VisitTypeSelectField = class VisitTypeSelectField extends (
  AppointmentBooking.Wizard.Views.Field
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    return this.listenTo(this.model, "change:validated_visit_type_id", this.render);
  }
};
AppointmentBooking.Wizard.Views.ConfirmationStep.VisitTypeSelectField.prototype.template =
  "step/confirmation/fields/visit_type";
AppointmentBooking.Wizard.Views.ConfirmationStep.VisitTypeSelectField.prototype.className =
  "appointment-booking-wizard-confirmation-step-visit-type-select-field";
